import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScheduleTypes = api(async function scheduleTypesForRules() {
    return query(
        gql`
            query GetScheduleTypesForRules {
                scheduleTypesForRules {
                    id
                    name
                }
            }
        `,
        {},
        { returns: "scheduleTypesForRules" }
    )
})
